import { createFileRoute } from "@tanstack/react-router";

import { PlatformHead, PlatformPage } from "@/features/platform/components/platform-chrome";
import { PlatformClosing } from "@/features/platform/modules/closing/platform-closing";
import { PricingHero, PricingValue } from "@/features/platform/modules/pricing-page/pricing-page";
import { PlatformPricing } from "@/features/platform/modules/pricing/platform-pricing";
import { PlatformQuestions } from "@/features/platform/modules/questions/platform-questions";
import { pageMeta } from "@/lib/seo";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(public)/pricing/")({
  head: () => ({
    meta: pageMeta({ title: m.seo_pricing_title(), description: m.seo_pricing_description() }),
  }),
  loader: () => ({ crumb: m.platform_nav_pricing() }),
  component: PricingPage,
});

/**
 * The platform's price list as a page of its own, so the link survives being pasted into a
 * message: the hero, the plans right under it, what the money buys, and the usual questions.
 */
function PricingPage() {
  return (
    <PlatformPage
      head={
        <PlatformHead>
          <PricingHero />
        </PlatformHead>
      }
    >
      <PlatformPricing headless />
      <PricingValue />
      <PlatformQuestions />
      <PlatformClosing />
    </PlatformPage>
  );
}
